<script setup lang="ts">
  import { useScreenSize } from '@/shared/lib'

  import { DefaultLayoutHeader, DefaultLayoutSidebar } from '@/widgets/layout'

  const { fromDesktopMedium, isMobile } = storeToRefs(useScreenSize())

  const showSidebar = ref(true)
  const setOverflow = (value: boolean) => {
    document.body.style.overflow = value ? 'hidden' : 'visible'
    document.body.style.height = value ? '100vh' : 'auto'
  }
  const handleToggleSidebar = () => {
    if (!fromDesktopMedium.value) {
      showSidebar.value = !showSidebar.value
    }

    if (isMobile.value) {
      setOverflow(showSidebar.value)
    }
  }
  watch(
    () => fromDesktopMedium.value,
    (value) => {
      showSidebar.value = value
    },
    {
      immediate: true,
    },
  )
  watchEffect(() => {
    if (!isMobile.value) {
      setOverflow(false)
    }
  })
</script>

<template>
  <div class="bg-surface-bg box-border flex flex-col items-center justify-start">
    <DefaultLayoutHeader
      v-model="showSidebar"
      @toggle-burger="handleToggleSidebar"
    />
    <div class="max-desktop-medium:pl-0 flex w-full max-w-7xl flex-row items-stretch justify-center">
      <DefaultLayoutSidebar
        v-if="showSidebar"
        @close-sidebar="handleToggleSidebar"
      />
      <div
        class="max-desktop-medium:w-full max-mobile:flex max-mobile:flex-col max-mobile:justify-start max-mobile:items-center max-mobile:p-4 border-l-border bg-surface-bg min-h-screen-content z-2 flex-1 py-4 pr-0 pl-4"
      >
        <slot name="default" />
      </div>
    </div>
  </div>
</template>
